import { ListItem, ListItemLabel } from "baseui/list";
import { AutomationObjectsListSelector, AutomationObjectsSelector, HasListPanel } from "../../automationObjects/automationObjectsSelector";
import { DefaultGrid, GridCardCell } from "../../automationObjects/components/Grid"
import { Notification } from "baseui/notification";
import { AiOutlineEyeInvisible } from "react-icons/ai";
import { Block } from "baseui/block";
import { useStyletron } from "baseui";

const ParametersView = ({ children }) => {
    const [css, theme] = useStyletron();
    
    return (
        <>

                {children?.map((item: any, index: number) => (
                    <>
                        {HasListPanel(item.schema) && <AutomationObjectsListSelector key={item.id} tag={item.schema} state={item}></AutomationObjectsListSelector>}
                        {!HasListPanel(item.schema) && <AutomationObjectsSelector key={item.id} tag={item.schema} state={item}></AutomationObjectsSelector>}
                    </>
                ))}
            {children && children.length === 0 && <Notification overrides={{
                Body: {
                    style: ({ $theme }) => ({
                        backgroundColor: $theme.colors.backgroundTertiary
                    })
                }
            }}>
                {() => <Block alignItems={'center'} display='inline-flex' gridGap={'20px'}><AiOutlineEyeInvisible></AiOutlineEyeInvisible> <>No items found.</></Block>}
            </Notification>}
        </>
    )
}

export default ParametersView;